import { createRoot } from "react-dom/client";

import MainLayout from "@/app/layouts/MainLayout";
import {
  RootStoreProvider,
  RouterProvider,
  SnackbarProvider,
  ThemeProvider,
} from "@/app/providers";

import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <RootStoreProvider>
    <RouterProvider>
      <ThemeProvider>
        <MainLayout>
          <App />
        </MainLayout>
        <SnackbarProvider />
      </ThemeProvider>
    </RouterProvider>
  </RootStoreProvider>
);
